/**
 * /privacy — public LGPD-aware privacy policy. Content in the `legal` i18n
 * namespace (4 languages); layout shared with /terms via LegalPage.
 */
import { useTranslation } from 'react-i18next';
import { useSeo } from '@/lib/seo';
import { LegalPage, type LegalSection } from './LegalPage';

// Element ids aligned by index with legal:privacy.sections — keeps the JSON
// pure text while /privacy#cookies (footer link) still deep-links.
const PRIVACY_ANCHORS: (string | undefined)[] = [
  'controller',
  'data',
  'purposes',
  'cookies',
  'sharing',
  'retention',
  'rights',
  'lead-owners',
  'contact',
];

export default function Privacy() {
  const { t } = useTranslation();
  useSeo({ title: t('legal:privacy.title'), description: t('legal:privacy.intro'), canonicalPath: '/privacy' });
  const sections = t('legal:privacy.sections', { returnObjects: true }) as LegalSection[];
  return (
    <LegalPage
      title={t('legal:privacy.title')}
      intro={t('legal:privacy.intro')}
      sections={sections}
      anchors={PRIVACY_ANCHORS}
    />
  );
}
